/**
 * STREAM_FEED — то, что юзер сохраняет в избранное.
 * Не реплики из чата, а имитация реального букмарк-контента:
 *  - рецепты — с ингредиентами в одну-две строки
 *  - игры/фильмы/книги — название + ссылка магазина
 *  - каналы — заголовок подборки + ссылка на пост
 *  - заметки самому себе — короткие напоминания
 */

export type StreamItem = {
  text: string;
  senderName: string;
  senderInitial: string;
  senderColor: string;
};

export const STREAM_FEED: StreamItem[] = [
  {
    text: 'Блинчики на кефире:\nкефир 500мл, мука 1.5ст, яйцо, сахар 2ст.л., сода. Жарь без масла.',
    senderName: 'мама',           senderInitial: 'м', senderColor: '#d49a3f',
  },
  {
    text: '15 русских фильмов 2026, которые стоят вечера\nt.me/kinoblog/8821',
    senderName: 'Кино-чат',       senderInitial: 'К', senderColor: '#c25a4c',
  },
  {
    text: 'Hollow Knight: Silksong\nstore.steampowered.com/app/1030300',
    senderName: 'Антон',          senderInitial: 'А', senderColor: '#7b8be5',
  },
  {
    text: '10 книг, которые перевернут год\nt.me/bookschannel/452',
    senderName: 'Книги до 30',    senderInitial: 'К', senderColor: '#5a7558',
  },
  {
    text: 'Паста с лососем:\nдобавь сливки в конце, не кипяти. Соль, перец, тимьян.',
    senderName: 'мама',           senderInitial: 'м', senderColor: '#d49a3f',
  },
  {
    text: 'Форест Гамп (1994)\nkinopoisk.ru/film/448',
    senderName: 'Маша',           senderInitial: 'М', senderColor: '#e57b7b',
  },
  {
    text: 'Кофейня «Прокуратор», Покровка 17\nyandex.ru/maps/-/CDQABZpV',
    senderName: 'Лена',           senderInitial: 'Л', senderColor: '#6b9e7f',
  },
  {
    text: '«1984», Джордж Оруэлл\nlitres.ru/dzhordzh-oruell/1984/',
    senderName: 'Книги до 30',    senderInitial: 'К', senderColor: '#5a7558',
  },
  {
    text: 'Досмотреть Severance s2',
    senderName: 'заметка',        senderInitial: '·', senderColor: '#7a8a79',
  },
  {
    text: 'youtu.be/8jPQjjsBbIc\nрилс — упал со смеху',
    senderName: 'Антон',          senderInitial: 'А', senderColor: '#7b8be5',
  },
  {
    text: 'Топ-7 мобильных игр марта\nt.me/gameschannel/2231',
    senderName: 'Game Channel',   senderInitial: 'G', senderColor: '#4a6e8e',
  },
  {
    text: 'Выставка «Без названия»\nГараж, до 30 марта · garagemca.org',
    senderName: 'Афиша',          senderInitial: 'А', senderColor: '#b07b3c',
  },
  {
    text: 'Пирог с яблоками (бабушкин):\n3 яблока, мука 200г, масло 100г, сахар 100г. 180° 35 мин.',
    senderName: 'мама',           senderInitial: 'м', senderColor: '#d49a3f',
  },
  {
    text: 'Бар «Profsoyuz», Чистые пруды\nновое место, проверим в субботу',
    senderName: 'Лена',           senderInitial: 'Л', senderColor: '#6b9e7f',
  },
  {
    text: 'Промпт ChatGPT:\n«Выдели 5 главных тезисов и сократи до 200 слов»',
    senderName: 'заметка',        senderInitial: '·', senderColor: '#7a8a79',
  },
  {
    text: 'Что посмотреть на Apple TV+ весной\ntelegra.ph/Apple-TV-spring-03-15',
    senderName: 'TV-канал',       senderInitial: 'T', senderColor: '#3a7e6e',
  },
  {
    text: 'Among Us\namongus.us — давай сегодня вечером',
    senderName: 'Антон',          senderInitial: 'А', senderColor: '#7b8be5',
  },
  {
    text: 'Хичкок — «Окно во двор» (1954)\nivi.ru/watch/12453',
    senderName: 'Кино-чат',       senderInitial: 'К', senderColor: '#c25a4c',
  },
  {
    text: 'Идея для презентации в пятницу:\nвзять 3 кейса клиентов, сравнить до/после',
    senderName: 'заметка',        senderInitial: '·', senderColor: '#7a8a79',
  },
  {
    text: 'Маринад для шашлыка:\nкефир + лук + специи на 4 часа, не больше.',
    senderName: 'мама',           senderInitial: 'м', senderColor: '#d49a3f',
  },
  {
    text: 'Дудь, новый выпуск\nyoutu.be/zXkqdC7nL4Q',
    senderName: 'Маша',           senderInitial: 'М', senderColor: '#e57b7b',
  },
];
